import {
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { CMPS_WIDGET_OPTIONS } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import {
    PillarPerformancePopup,
    PillarPerformancePopupItem,
} from './pillar-performance.widget.model';

@Component({
    selector: 'cmps-widget-pillar-performance',
    templateUrl: './pillar-performance.widget.component.html',
})
export class PillarPerformanceWidgetComponent implements OnInit, OnDestroy {
    @Input()
    options: any;

    i18n = TranslationKeyMap;
    private _sub: Subscription;
    hasPendingData: boolean;
    data: PillarPerformancePopup;

    get items(): PillarPerformancePopupItem[] {
        return this.options.pillarIds
            .map((value) =>
                this.data.items.find((value2) => value2.id === value),
            )
            .filter((value) => value != null);
    }

    constructor(
        @Optional() @Inject(CMPS_WIDGET_OPTIONS) private readonly _options: any,
        private readonly _widgetService: WidgetService,
        private readonly _service: LegacyWidgetService,
    ) {
        this.options = _options || this.options || {};
        this.options.pillarIds = this.options.pillarIds || [];
    }

    ngOnInit(): void {
        this._sub = this._widgetService.dateRange.subscribe((dateRange) => {
            this.data = null;
            this.hasPendingData = true;
            this._service
                .pillarPerformancePopup(this.options.definitionId)
                // eslint-disable-next-line no-return-assign
                .subscribe(
                    (data) => (this.data = data),
                    // eslint-disable-next-line n/handle-callback-err, no-return-assign
                    (error) => (this.hasPendingData = false),
                    // eslint-disable-next-line no-return-assign
                    () => (this.hasPendingData = false),
                );
        });
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }
}
